import script from "./BottlePrintAreaPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./BottlePrintAreaPreview.vue?vue&type=script&setup=true&lang=js"

import "./BottlePrintAreaPreview.vue?vue&type=style&index=0&id=4933d61c&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/packperform.com/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4933d61c"]])

export default __exports__